module.exports = __webpack_public_path__ + "media/40.1aae2930.mp3";